var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgHeaderOnline = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), /* @__PURE__ */ React.createElement("path", {
  "data-name": "\\u77E9\\u5F62 4354",
  fill: "none",
  d: "M0 0h20v20H0z"
}), /* @__PURE__ */ React.createElement("path", {
  "data-name": "\\u8DEF\\u5F84 11900",
  d: "M19.285 9.286v7.143A3.571 3.571 0 0 1 15.714 20h-5a.715.715 0 0 1 0-1.429h5a2.143 2.143 0 0 0 2.143-2.143h-2.143a2.143 2.143 0 0 1-2.143-2.143v-3.57a2.143 2.143 0 0 1 2.143-2.143h2.112a7.858 7.858 0 0 0-15.651 0h2.111a2.143 2.143 0 0 1 2.143 2.143v3.571a2.143 2.143 0 0 1-2.143 2.143H2.857a2.143 2.143 0 0 1-2.143-2.143v-5a9.286 9.286 0 1 1 18.571 0Z",
  fill: "#fff"
}));
export { SvgHeaderOnline as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PHBhdGggZGF0YS1uYW1lPSLnn6nlvaIgNDM1NCIgZmlsbD0ibm9uZSIgZD0iTTAgMGgyMHYyMEgweiIvPjxwYXRoIGRhdGEtbmFtZT0i6Lev5b6EIDExOTAwIiBkPSJNMTkuMjg1IDkuMjg2djcuMTQzQTMuNTcxIDMuNTcxIDAgMCAxIDE1LjcxNCAyMGgtNWEuNzE1LjcxNSAwIDAgMSAwLTEuNDI5aDVhMi4xNDMgMi4xNDMgMCAwIDAgMi4xNDMtMi4xNDNoLTIuMTQzYTIuMTQzIDIuMTQzIDAgMCAxLTIuMTQzLTIuMTQzdi0zLjU3YTIuMTQzIDIuMTQzIDAgMCAxIDIuMTQzLTIuMTQzaDIuMTEyYTcuODU4IDcuODU4IDAgMCAwLTE1LjY1MSAwaDIuMTExYTIuMTQzIDIuMTQzIDAgMCAxIDIuMTQzIDIuMTQzdjMuNTcxYTIuMTQzIDIuMTQzIDAgMCAxLTIuMTQzIDIuMTQzSDIuODU3YTIuMTQzIDIuMTQzIDAgMCAxLTIuMTQzLTIuMTQzdi01YTkuMjg2IDkuMjg2IDAgMSAxIDE4LjU3MSAwWiIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg==";
